import { render, staticRenderFns } from "./GameCard.vue?vue&type=template&id=82ce7446&scoped=true&"
import script from "./GameCard.vue?vue&type=script&lang=ts&"
export * from "./GameCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ce7446",
  null
  
)

export default component.exports